import React from "react";
import { Navigate } from "react-router-dom";
import { usePageAccess, usePlanFeature } from "../contexts/CurrentUserContext";
import { usePaywall } from "./PaywallModal";
import type { PlanFeatureKey } from "../hooks/useCurrentUser";

interface PlanFeatureGateProps {
  feature: PlanFeatureKey;
  children: React.ReactNode;
  reason?: string;
}

export function PlanFeatureGate({
  feature,
  children,
  reason,
}: PlanFeatureGateProps): React.ReactElement {
  const { loading, tenantSlug } = usePageAccess();
  const canUseFeature = usePlanFeature(feature);
  const { open } = usePaywall();

  React.useEffect(() => {
    if (loading || canUseFeature) return;
    open(feature, { reason });
  }, [canUseFeature, feature, loading, open, reason]);

  if (loading) {
    return <></>;
  }

  if (!canUseFeature) {
    return <Navigate to={tenantSlug ? `/t/${tenantSlug}` : "/dashboard"} replace />;
  }

  return <>{children}</>;
}
